export default "__VITE_ASSET__BPMqyT8J__"